/* eslint-disable max-len */
const termsOfUseContent = {
  meta: {
    company: 'CÔNG TY TNHH TM DV BOOKESE VIỆT NAM',
    title: 'ĐIỀU KHOẢN VÀ ĐIỀU KIỆN SỬ DỤNG BOOKESE',
    subtitle: 'LƯU TRÚ  •  VÉ MÁY BAY  •  VÉ THAM QUAN VÀ TRẢI NGHIỆM',
    intro: 'Điều khoản này áp dụng chung cho dịch vụ lưu trú, vé máy bay và vé tham quan, trải nghiệm được cung cấp qua Bookese. Tài liệu giải thích quyền và nghĩa vụ của khách hàng, thời điểm đặt chỗ được xác nhận, cách thanh toán, thay đổi, hủy và liên hệ hỗ trợ. Điều kiện riêng về giá, lịch sử dụng, đổi, hủy và hoàn tiền của từng sản phẩm được hiển thị để khách rà soát trước khi đặt.',
  },
  sections: [
    {
      id: 'dieu-1',
      title: 'Điều 1. Chủ thể vận hành và tài liệu áp dụng',
      items: [
        {
          id: '1.1',
          title: '1.1',
          content: [
            'Bookese do CÔNG TY TNHH TM DV BOOKESE VIỆT NAM vận hành; mã số doanh nghiệp/mã số thuế 0319613120; địa chỉ: Tầng 12 (1206), CitiLight Tower, 45 Võ Thị Sáu, Phường Tân Định, Thành phố Hồ Chí Minh, Việt Nam; email info@bookese.com; tổng đài 078 222 1131.',
          ],
        },
        {
          id: '1.2',
          title: '1.2',
          content: [
            'Điều khoản này áp dụng cho khách truy cập, người tạo tài khoản, người đặt dịch vụ và người sử dụng dịch vụ trên bookese.com. Khi sử dụng một tính năng có yêu cầu xác nhận Điều khoản, khách cần có cơ hội xem nội dung trước khi xác nhận. Việc đặt dịch vụ còn chịu điều kiện riêng của sản phẩm được hiển thị tại trang dịch vụ và bước rà soát đơn.',
          ],
        },
        {
          id: '1.3',
          title: '1.3',
          content: [
            '“Quy chế hoạt động nền tảng thương mại điện tử Bookese” mô tả quy trình và trách nhiệm của các bên trên nền tảng. “Chính sách bảo vệ dữ liệu cá nhân” mô tả hoạt động xử lý dữ liệu. Nếu có khác biệt về đặc điểm, giá, thời gian hoặc điều kiện hủy của một sản phẩm, thông tin riêng đã được công bố và khách xác nhận tại thời điểm đặt được áp dụng cho giao dịch đó, nhưng không được trái quy định bắt buộc của pháp luật hoặc hạn chế quyền hợp pháp của người tiêu dùng. Các tài liệu luôn được công bố để khách lưu và tra cứu.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-2',
      title: 'Điều 2. Vai trò của Bookese và nhà cung cấp',
      items: [
        {
          id: '2.1',
          title: '2.1',
          content: [
            'Bookese cung cấp công cụ tìm kiếm, hiển thị thông tin, tiếp nhận yêu cầu đặt, hỗ trợ thanh toán, xác nhận và chăm sóc giao dịch. Dịch vụ lưu trú do cơ sở lưu trú thực hiện; chuyến bay do hãng hàng không thực hiện; hoạt động tham quan, trải nghiệm do đơn vị tổ chức hoặc cung cấp thực hiện. Danh tính bên cung cấp, bên thu tiền và bên xuất hóa đơn được nêu tại thông tin sản phẩm, bước thanh toán hoặc chứng từ xác nhận. Khi Bookese trực tiếp là bên bán, Bookese chịu trách nhiệm của bên cung cấp đối với giao dịch đó.',
          ],
        },
        {
          id: '2.2',
          title: '2.2',
          content: [
            'Bookese chịu trách nhiệm về nghĩa vụ của chủ quản nền tảng, về thông tin hoặc cam kết do chính Bookese đưa ra, lỗi thuộc hệ thống hoặc nhân sự Bookese và các trường hợp pháp luật quy định. Nhà cung cấp chịu trách nhiệm thực hiện dịch vụ đúng mô tả, chất lượng, điều kiện đã xác nhận và nghĩa vụ pháp lý của mình. Các bên phối hợp giải quyết yêu cầu của khách; khách không phải tự xác định lỗi giữa các bên trước khi gửi khiếu nại cho Bookese.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-3',
      title: 'Điều 3. Điều kiện sử dụng và tài khoản',
      items: [
        {
          id: '3.1',
          title: '3.1',
          content: [
            'Người tạo tài khoản và đặt dịch vụ phải từ đủ 18 tuổi hoặc có đủ năng lực, thẩm quyền theo pháp luật để giao dịch. Trường hợp đặt cho người khác, khách bảo đảm đã được phép cung cấp thông tin cần thiết và chuyển cho họ thông tin quan trọng về dịch vụ, Điều khoản này và chính sách dữ liệu cá nhân.',
          ],
        },
        {
          id: '3.2',
          title: '3.2',
          content: [
            'Khách cung cấp họ tên, email, số điện thoại và thông tin đặt chỗ chính xác, cập nhật khi thay đổi; giữ bí mật mật khẩu, mã xác thực và thiết bị đăng nhập; thông báo ngay cho Bookese nếu nghi ngờ tài khoản bị sử dụng trái phép. Bookese không hỏi mật khẩu hoặc mã OTP qua điện thoại, email hay chat.',
          ],
        },
        {
          id: '3.3',
          title: '3.3',
          content: [
            'Khách có thể yêu cầu hỗ trợ sửa hoặc đóng tài khoản qua info@bookese.com. Việc đóng tài khoản không tự động hủy các đặt chỗ còn hiệu lực hoặc xóa chứng từ phải lưu theo pháp luật. Quyền đối với dữ liệu cá nhân được thực hiện theo Chính sách bảo vệ dữ liệu cá nhân.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-4',
      title: 'Điều 4. Tìm kiếm, thông tin dịch vụ và giá',
      items: [
        {
          id: '4.1',
          title: '4.1',
          content: [
            'Bookese hiển thị mô tả, hình ảnh, tình trạng còn chỗ, điều kiện sử dụng và giá từ nhà cung cấp hoặc nguồn phân phối được phép. Bookese rà soát và cập nhật theo khả năng hệ thống; khách nên kiểm tra thông tin cuối cùng tại bước rà soát trước khi gửi đơn. Nếu phát hiện thông tin không chính xác hoặc thiếu nội dung quan trọng, khách liên hệ Bookese trước khi thanh toán.',
          ],
        },
        {
          id: '4.2',
          title: '4.2',
          content: [
            'Giá, thuế, phí bắt buộc, phụ phí tại nơi sử dụng, dịch vụ tùy chọn và tổng phải trả được hiển thị trước khi khách xác nhận. Giá và tồn chỗ có thể thay đổi trước khi giao dịch được xác nhận. Nếu giá hoặc điều kiện thay đổi trong quá trình đặt, Bookese thông báo để khách chọn tiếp tục hoặc dừng; Bookese không tự tăng số tiền khách đã đồng ý thanh toán.',
          ],
        },
        {
          id: '4.3',
          title: '4.3',
          content: [
            'Kết quả tìm kiếm có thể được sắp xếp theo mức phù hợp, giá, vị trí, tình trạng còn chỗ, đánh giá và chất lượng thông tin. Nội dung tài trợ hoặc ưu tiên có trả phí, nếu có, phải được đánh dấu phân biệt. Đánh giá của khách không phải bảo đảm của Bookese về chất lượng dịch vụ trong mọi thời điểm.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-5',
      title: 'Điều 5. Quy trình đặt và thời điểm xác nhận',
      items: [
        {
          id: '5.1',
          title: '5.1',
          content: [
            'Khách chọn dịch vụ, ngày giờ, số lượng, phương án giá và dịch vụ bổ sung; nhập thông tin người sử dụng; rà soát toàn bộ nội dung đơn, tổng tiền và điều kiện đổi/hủy/hoàn; chỉnh sửa nếu cần; sau đó chọn thanh toán hoặc gửi yêu cầu đặt. Bookese ghi nhận yêu cầu và thông báo trạng thái qua website hoặc thông tin liên hệ khách cung cấp.',
          ],
        },
        {
          id: '5.2',
          title: '5.2',
          content: [
            'Việc nhận yêu cầu, mã giao dịch thanh toán hoặc thao tác giữ tiền chưa đồng nghĩa dịch vụ đã được xác nhận. Đặt chỗ có hiệu lực khi Bookese hoặc nhà cung cấp gửi xác nhận kèm mã đặt chỗ, số vé điện tử, voucher hoặc thông tin tương đương. Khách cần kiểm tra xác nhận và báo sai sót ngay để được hỗ trợ xử lý.',
          ],
        },
        {
          id: '5.3',
          title: '5.3',
          content: [
            'Nếu dịch vụ không còn khả dụng hoặc không thể xác nhận sau khi đã thu tiền, Bookese thông báo lý do và lựa chọn xử lý cho khách; khoản đã thu cho phần không được cung cấp được hoàn theo quy định, trừ khi khách đồng ý phương án thay thế. Bookese không buộc khách nhận dịch vụ khác hoặc voucher thay tiền hoàn trái với quyền của khách.',
          ],
        },
        {
          id: '5.4',
          title: '5.4',
          content: [
            'Khách cần hoàn tất thanh toán trong thời hạn hiển thị cho đơn. Khi hết thời hạn mà giao dịch chưa được thanh toán hoặc chưa được nhà cung cấp xác nhận, yêu cầu đặt có thể hết hiệu lực; khách cần kiểm tra lại giá và chỗ còn trước khi đặt lại. Xác nhận đặt phòng, vé điện tử hoặc voucher được gửi qua email, tài khoản Bookese hay kênh được nêu ở bước đặt. Bookese không giao chứng từ giấy tại địa chỉ khách, trừ khi sản phẩm có thông báo riêng.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-6',
      title: 'Điều 6. Điều kiện riêng theo nhóm dịch vụ',
      items: [
        {
          id: '6.1',
          title: '6.1. Lưu trú',
          content: [
            'Khách kiểm tra cơ sở lưu trú, loại phòng, ngày nhận và trả phòng, số người, bữa ăn, tiện ích, phụ thu, đặt cọc, giờ nhận/trả phòng và điều kiện hủy của đúng gói giá. Khách xuất trình xác nhận và giấy tờ hợp lệ theo yêu cầu đã công bố. Cơ sở lưu trú trực tiếp cung cấp phòng. Nếu không có phòng đúng cam kết hoặc mô tả sai đáng kể, Bookese là đầu mối hỗ trợ đổi phòng/cơ sở phù hợp khi khách đồng ý, hoàn tiền và giải quyết thiệt hại theo trách nhiệm của từng bên và pháp luật.',
          ],
        },
        {
          id: '6.2',
          title: '6.2. Vé máy bay',
          content: [
            'Khi đặt vé máy bay, khách nhập chính xác họ tên theo giấy tờ đi lại và các dữ liệu hãng yêu cầu; kiểm tra hành trình, sân bay, giờ bay, hạng vé, hành lý, dịch vụ bổ sung, điều kiện giá, phí và quy định đổi/hủy trước khi thanh toán. Vé chỉ được coi là phát hành khi có số vé điện tử hoặc xác nhận hợp lệ. Hãng hàng không thực hiện vận chuyển và áp dụng điều kiện chuyên chở được công bố; Bookese hỗ trợ phát hành, chuyển yêu cầu thay đổi và theo dõi hoàn tiền theo vai trò trong đơn. Khách tự chuẩn bị giấy tờ, thị thực và đáp ứng điều kiện xuất nhập cảnh, trừ trường hợp Bookese có cam kết dịch vụ riêng. Chính sách lỡ chuyến, không bay hoặc chỉ sử dụng một chặng phụ thuộc điều kiện vé, hãng và pháp luật áp dụng.',
          ],
        },
        {
          id: '6.3',
          title: '6.3. Vé tham quan và trải nghiệm',
          content: [
            'Khi đặt vé tham quan và trải nghiệm, khách kiểm tra ngày giờ, địa điểm, cách nhận hoặc quét vé, thời hạn sử dụng, số lần vào cửa, giới hạn độ tuổi/sức khỏe, yêu cầu đặt trước, hạng mục bao gồm/không bao gồm và điều kiện đổi/hủy. Nhà cung cấp trực tiếp tổ chức và bảo đảm chất lượng, an toàn hoạt động. Nếu điểm tham quan đóng cửa hoặc lịch hoạt động thay đổi đáng kể, Bookese phối hợp thông báo và xử lý đổi lịch, thay thế hoặc hoàn tiền theo điều kiện công bố và pháp luật.',
          ],
        },
        {
          id: '6.4',
          title: '6.4. Yêu cầu đặc biệt và sử dụng dịch vụ',
          content: [
            'Khách có thể gửi yêu cầu đặc biệt như phòng phù hợp người khuyết tật, nhận phòng muộn, suất ăn hoặc hỗ trợ tại sân bay/điểm tham quan qua chức năng hoặc kênh hỗ trợ được công bố. Yêu cầu chỉ được bảo đảm khi nhà cung cấp xác nhận. Khách cần có mặt đúng thời gian, địa điểm, mang giấy tờ và tuân thủ quy định an toàn, điều kiện tham gia đã được thông báo. Nếu đến muộn, không đến hoặc chỉ sử dụng một phần dịch vụ, quyền sử dụng phần còn lại và khả năng hoàn tiền được xác định theo điều kiện sản phẩm, quy định của nhà cung cấp và pháp luật áp dụng.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-7',
      title: 'Điều 7. Thanh toán, hóa đơn và ưu đãi',
      items: [
        {
          id: '7.1',
          title: '7.1',
          content: [
            'Khách thanh toán bằng phương thức được hiển thị tại bước thanh toán; website hỗ trợ thẻ nội địa, thẻ quốc tế và mã QR. Phương thức áp dụng cho từng giao dịch được xác định tại bước thanh toán. Giao dịch được xử lý qua đối tác thanh toán hợp pháp. Khách chỉ thanh toán theo hướng dẫn chính thức trên bookese.com hoặc thông báo xác thực từ Bookese.',
          ],
        },
        {
          id: '7.2',
          title: '7.2',
          content: [
            'Chủ thể xuất hóa đơn được thể hiện trong giao dịch. Khách cung cấp thông tin hóa đơn đúng và trong thời điểm được hướng dẫn. Nếu thanh toán thất bại, bị ghi nhận hai lần hoặc đơn chưa được xác nhận, khách gửi mã giao dịch và chứng từ qua kênh hỗ trợ để Bookese đối soát.',
          ],
        },
        {
          id: '7.3',
          title: '7.3',
          content: [
            'Mã giảm giá, voucher, xu/điểm và quà tặng áp dụng theo thể lệ riêng được công bố trước khi dùng, gồm thời gian, đối tượng, mức trừ, khả năng kết hợp và cách xử lý khi đơn đổi/hủy. Xu/điểm không mặc nhiên là tiền mặt. Bookese không thay đổi thể lệ theo hướng bất lợi cho giao dịch đã xác nhận, trừ khi pháp luật yêu cầu hoặc các bên có thỏa thuận hợp lệ.',
          ],
        },
        {
          id: '7.4',
          title: '7.4',
          content: [
            'Phí dịch vụ hoặc phí tiện ích của Bookese, nếu có, được tách riêng và thông báo trước khi khách xác nhận thanh toán cùng điều kiện hoàn phí tương ứng. Các chi phí phát sinh theo lựa chọn của khách hoặc tại nơi sử dụng dịch vụ chỉ được thu theo thông tin đã công bố, thỏa thuận hợp lệ hoặc quy định pháp luật.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-8',
      title: 'Điều 8. Đổi, hủy, hoàn tiền và gián đoạn dịch vụ',
      items: [
        {
          id: '8.1',
          title: '8.1',
          content: [
            'Mỗi phòng, hạng vé hoặc hoạt động có điều kiện đổi/hủy/hoàn riêng. Khách xem chính sách cụ thể trước khi đặt và trong xác nhận. Phí và phần không hoàn, nếu có, phải được công bố rõ trước thanh toán. Yêu cầu của khách được tiếp nhận qua chức năng trên nền tảng hoặc kênh hỗ trợ; Bookese thông báo số tiền dự kiến được hoàn, các khoản phí có căn cứ và tiến độ xử lý.',
          ],
        },
        {
          id: '8.2',
          title: '8.2',
          content: [
            'Điều kiện “không hoàn hủy” không loại trừ quyền của khách khi bên cung cấp hoặc Bookese không thực hiện đúng nghĩa vụ, cung cấp dịch vụ sai nội dung đã xác nhận hoặc khi pháp luật quy định khách được hoàn/bồi thường. Khi sự cố thuộc bên cung cấp, Bookese tiếp nhận yêu cầu và phối hợp khắc phục, đổi dịch vụ khi khách đồng ý hoặc hoàn tiền, giải quyết thiệt hại theo pháp luật.',
          ],
        },
        {
          id: '8.3',
          title: '8.3',
          content: [
            'Khoản hoàn được chuyển về phương thức thanh toán ban đầu khi khả thi; phương thức khác chỉ dùng khi khách đồng ý và đã xác minh an toàn. Thời điểm tiền ghi có còn phụ thuộc ngân hàng/cổng thanh toán và nhà cung cấp. Bookese thông báo mốc xử lý cụ thể theo từng hồ sơ, đồng thời cập nhật nếu có chậm trễ.',
          ],
        },
        {
          id: '8.4',
          title: '8.4',
          content: [
            'Khi website lỗi, xác nhận chậm hoặc thanh toán gián đoạn, khách không nên thanh toán lặp lại trước khi kiểm tra trạng thái. Bookese duy trì kênh hỗ trợ và đối soát, bảo vệ quyền đối với đơn đã xác nhận; sự cố kỹ thuật không tự động miễn trách nhiệm của bên có lỗi.',
          ],
        },
        {
          id: '8.5',
          title: '8.5',
          content: [
            'Khi hãng hàng không, cơ sở lưu trú hoặc đơn vị tổ chức thay đổi lịch, hủy dịch vụ, đóng cửa điểm tham quan hoặc khi xảy ra sự kiện ngoài khả năng kiểm soát hợp lý của các bên như thiên tai, thời tiết nguy hiểm, dịch bệnh hay quyết định của cơ quan có thẩm quyền, Bookese thông báo thông tin nhận được và phối hợp với nhà cung cấp đưa ra lựa chọn đổi lịch, dịch vụ thay thế hoặc hoàn tiền. Khách được biết điều kiện, chênh lệch giá và khoản hoàn trước khi quyết định. Việc phân định trách nhiệm và bồi thường được thực hiện theo thỏa thuận hợp lệ và pháp luật; sự kiện bất khả kháng không tự động xóa quyền được hoàn khoản tiền cho dịch vụ không được cung cấp.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-9',
      title: 'Điều 9. Quyền và nghĩa vụ của khách hàng',
      items: [
        {
          id: '9.1',
          title: '9.1',
          content: [
            'Khách có quyền nhận thông tin đầy đủ, rõ ràng; rà soát đơn trước khi đặt; nhận xác nhận và chứng từ; yêu cầu hỗ trợ, đổi/hủy/hoàn, khiếu nại và bồi thường theo thỏa thuận hợp lệ, điều kiện sản phẩm và pháp luật.',
          ],
        },
        {
          id: '9.2',
          title: '9.2',
          content: [
            'Khách cung cấp thông tin chính xác, thanh toán đúng hạn, tuân thủ quy định hợp pháp của nhà cung cấp đã được thông báo, sử dụng dịch vụ đúng mục đích, bảo vệ tài khoản và tôn trọng quyền của người khác. Khách không đặt chỗ giả, sử dụng tài khoản trái phép, khai thác lỗi hệ thống, phát tán mã độc, gian lận ưu đãi hoặc đăng đánh giá sai sự thật.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-10',
      title: 'Điều 10. Nội dung, đánh giá và sở hữu trí tuệ',
      items: [
        {
          id: '10.1',
          title: '10.1',
          content: [
            'Khách có thể gửi đánh giá cho giao dịch đủ điều kiện. Nội dung cần dựa trên trải nghiệm thực tế, không xúc phạm, tiết lộ dữ liệu cá nhân của người khác, quảng cáo hoặc vi phạm pháp luật. Bookese có thể ẩn hoặc gỡ nội dung vi phạm và thông báo lý do phù hợp; đánh giá hợp lệ không bị xóa chỉ vì bất lợi cho nhà cung cấp.',
          ],
        },
        {
          id: '10.2',
          title: '10.2',
          content: [
            'Tên, nhãn hiệu, giao diện, phần mềm và nội dung do Bookese hoặc bên cấp quyền cung cấp được bảo vệ theo pháp luật sở hữu trí tuệ. Khách được sử dụng website cho mục đích tìm kiếm và đặt dịch vụ hợp pháp; không sao chép quy mô lớn, khai thác tự động gây ảnh hưởng hệ thống hoặc dùng thương hiệu Bookese khi chưa được cho phép. Quyền của khách đối với nội dung do khách tạo vẫn được bảo lưu; khách cho phép Bookese hiển thị nội dung đã gửi trong phạm vi chức năng đánh giá và xử lý khiếu nại, theo chính sách dữ liệu và pháp luật.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-11',
      title: 'Điều 11. Bảo vệ dữ liệu cá nhân',
      items: [],
      paragraphs: [
        'Bookese xử lý dữ liệu theo Chính sách bảo vệ dữ liệu cá nhân công bố trên website, bao gồm dữ liệu tài khoản, thông tin khách lưu trú, thông tin hành khách và thông tin người tham gia trải nghiệm. Dữ liệu chỉ được chia sẻ trong phạm vi cần thiết với nhà cung cấp, hệ thống phân phối, đối tác thanh toán và bên hỗ trợ để thực hiện giao dịch hoặc theo quy định pháp luật. Khách có thể gửi yêu cầu về quyền dữ liệu tới info@bookese.com. Bookese công bố và cập nhật chính sách dữ liệu phù hợp với các loại dữ liệu thực tế được thu thập.',
      ],
    },
    {
      id: 'dieu-12',
      title: 'Điều 12. Tạm ngừng tài khoản và chấm dứt sử dụng',
      items: [],
      paragraphs: [
        'Bookese có thể cảnh báo, tạm hạn chế hoặc đóng tài khoản khi có căn cứ hợp lý về gian lận, vi phạm nghiêm trọng Điều khoản, đe dọa an toàn hệ thống hoặc yêu cầu của cơ quan có thẩm quyền. Bookese thông báo lý do và kênh khiếu nại, trừ khi việc thông báo bị pháp luật cấm hoặc cản trở ngăn chặn rủi ro. Biện pháp phải tương xứng với vi phạm. Các đặt chỗ đã xác nhận, khoản tiền và quyền khiếu nại được xử lý độc lập, không tự động mất hiệu lực vì tài khoản bị hạn chế.',
      ],
    },
    {
      id: 'dieu-13',
      title: 'Điều 13. Khiếu nại và giải quyết tranh chấp',
      items: [
        {
          id: '13.1',
          title: '13.1',
          content: [
            'Khách gửi mã đặt chỗ, mô tả vấn đề và chứng cứ tới tổng đài 078 222 1131, email info@bookese.com, mục Liên hệ hỗ trợ trên website hoặc trụ sở Bookese. Theo Quy chế hoạt động, Bookese xác nhận tiếp nhận trong 24 giờ làm việc; dự kiến phản hồi vụ việc đơn giản trong 03 ngày làm việc, vụ việc cần xác minh nhiều bên trong 07 ngày làm việc và cập nhật tiến độ nếu kéo dài. Các mốc này không làm giảm quyền hoặc thời hạn bắt buộc theo pháp luật.',
          ],
        },
        {
          id: '13.2',
          title: '13.2',
          content: [
            'Bookese đối chiếu xác nhận đơn, điều kiện sản phẩm, chứng từ và ý kiến nhà cung cấp; thông báo kết quả, căn cứ và phương án khắc phục. Các bên ưu tiên thương lượng. Nếu không đạt kết quả, khách có quyền sử dụng cơ chế bảo vệ người tiêu dùng, hòa giải, trọng tài khi có thỏa thuận hợp lệ hoặc tòa án có thẩm quyền. Điều khoản này không buộc khách từ bỏ quyền khiếu nại, khởi kiện hay yêu cầu bồi thường theo pháp luật.',
          ],
        },
      ],
      paragraphs: [],
    },
    {
      id: 'dieu-14',
      title: 'Điều 14. Sửa đổi và hiệu lực',
      items: [
        {
          id: '14.1',
          title: '14.1',
          content: [
            'Điều khoản có hiệu lực từ ngày được công bố trên bookese.com. Bookese hiển thị phiên bản và ngày áp dụng, thông báo trước thay đổi quan trọng ảnh hưởng đến quyền, nghĩa vụ của khách bằng phương thức phù hợp và tạo điều kiện để khách xem nội dung mới trước khi tiếp tục giao dịch. Giao dịch đã xác nhận được xử lý theo điều kiện tại thời điểm đặt, trừ thay đổi có lợi cho khách hoặc trường hợp pháp luật yêu cầu khác.',
          ],
        },
        {
          id: '14.2',
          title: '14.2',
          content: [
            'Nếu một điều khoản không có hiệu lực theo pháp luật, phần còn lại vẫn áp dụng trong phạm vi hợp pháp. Điều khoản được giải thích theo pháp luật Việt Nam; quy định bắt buộc về bảo vệ người tiêu dùng và quyền của khách được ưu tiên áp dụng.',
          ],
        },
      ],
      paragraphs: [],
    },
  ],
};

export default termsOfUseContent;
